import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Badge } from 'react-bootstrap';
import { useApp } from 'common/context';
import { useSuperState } from "helpers/hooks";
import { FaCloud, FaChartBar, FaUsers, FaListOl, FaServer, FaCreditCard, FaSignOutAlt, FaExternalLinkSquareAlt } from "react-icons/fa";
import SessionCreator from 'pages/dashboard/components/SessionCreator';

import './styles/Sidebar.css';
import gmetrix_logo from "common/assets/logo_gmetrix_white.png";

const Sidebar = React.memo(props => {

    const [state, setState] = useSuperState({
        error: null,
        session_count: 0,
        queue_count: 0,
        instance_count: 0
    });

    const { session_count, queue_count, instance_count } = state;

    const { api } = useApp();
    const session_creator_ref = useRef();
    const interval_ref = useRef(null);

    const refreshLiveStats = async () => {

        await api.get('/api/appstream/stats/live').then(({ session_count, queue_count, instance_count }) => {

            setState({
                session_count,
                queue_count,
                instance_count
            });

        }).catch(() => {});

    };

    useEffect(() => {

        refreshLiveStats();

        interval_ref.current = setInterval(() => {

            refreshLiveStats();

        }, 5000);

        return () => {

            if (interval_ref.current)
                clearInterval(interval_ref.current);

        };

    }, []);

    const NavItem = ({ icon, name, href, count, onClick }) => {

        const is_active = location?.pathname == href;

        return (
            <Link to={href} className={"sidebar-menu-nav-item" + (is_active ? " active" : "")} onClick={onClick}>
                <div className="sidebar-menu-nav-icon">
                    {icon}
                </div>
                <div className="sidebar-menu-nav-link">
                    {name}
                    {typeof(count) == 'number' && <Badge className="ms-2">{count}</Badge>}
                </div>
            </Link>
        );};

    return (
        <>
            <div className="d-flex sidebar-container">
                <div className="sidebar-menu bg-navy">
                    <div className="p-3 sidebar-menu-header">
                        <div className="d-flex align-items-center">
                            <div className="me-2">
                                <FaCloud style={{ color: 'white' }} size={30}/>
                            </div>
                            <div className="sidebar-menu-header-logo">
                                <img src={gmetrix_logo} style={{ width: 165 }}/>
                                <h5 className="m-0 text-white">Cloud Manager</h5>
                            </div>
                        </div>
                    </div>

                    <hr style={{ color: 'white' }} className="m-0"/>

                    {/* Dashboard */}
                    <NavItem icon={<FaChartBar/>} name="Dashboard" href="/dashboard"/>

                    {/* Sessions */}
                    <NavItem icon={<FaUsers/>} name="Sessions" href="/dashboard/sessions" count={session_count}/>

                    {/* Queue */}
                    <NavItem icon={<FaListOl/>} name="Queue" href="/dashboard/queue" count={queue_count}/>

                    {/* Instances */}
                    <NavItem icon={<FaServer/>} name="Instances" href="/dashboard/instances" count={instance_count}/>

                    {/* Pricing */}
                    <NavItem icon={<FaCreditCard/>} name="Pricing" href="/dashboard/pricing"/>

                    {/* Start a Session */}
                    <NavItem icon={<FaExternalLinkSquareAlt/>} name="Start a Session" href="#" onClick={() => session_creator_ref.current.show()}/>

                    <hr style={{ color: 'white' }} className="m-0"/>

                    {/* Logout */}
                    <NavItem icon={<FaSignOutAlt/>} name="Logout" href="/logout"/>

                </div>
                <div className="sidebar-content px-sm-5">
                    {props?.children}
                </div>
            </div>
            <SessionCreator ref={session_creator_ref}/>
        </>
    );

});

export default Sidebar;
